import type { RaRecord } from "react-admin";

// FIXME: Should be of ProductRecord style ... :
export function rowStyles(_record: Readonly<RaRecord>, index: number): Record<string, string> {
    return {
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        backgroundColor: index % 2 === 0 ? "rgb(249, 249, 249)" : "white"
    };
}
